import { render, staticRenderFns } from "./notificacion-inferior.html?vue&type=template&id=4a931073&"
import script from "./notificacion-inferior.ts?vue&type=script&lang=ts&"
export * from "./notificacion-inferior.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports